import { observer } from 'mobx-react-lite';

import { YStack } from '@/components/ui/layout/layout';

import { useRoutinesLimitState } from './hooks/use-routines-limit-state';
import { ReferralCta } from './referral-cta';
import { subscriptionStore } from './subscription.store';
import { UpgradeBanner } from './upgrade-banner';

export const RoutinesLimitWarning = observer(
  ({ className }: { className?: string }) => {
    const { hasReachedLimit } = useRoutinesLimitState();
    const canUpgrade = subscriptionStore.canUpgrade;

    if (!hasReachedLimit) return null;

    return (
      <UpgradeBanner.Root className={className}>
        <UpgradeBanner.Content>
          <UpgradeBanner.Title>
            You've reached your routine limit
          </UpgradeBanner.Title>
          <UpgradeBanner.Description>
            {canUpgrade
              ? 'You can delete an existing routine to create a new one, or upgrade for more routines.'
              : 'You can delete an existing routine to create a new one.'}
          </UpgradeBanner.Description>
        </UpgradeBanner.Content>
        {canUpgrade && (
          <YStack className="items-end gap-1.5 shrink-0">
            <UpgradeBanner.UpgradeButton source="routines_limit_reached">
              Upgrade
            </UpgradeBanner.UpgradeButton>
            <ReferralCta source="routines_limit_reached" />
          </YStack>
        )}
      </UpgradeBanner.Root>
    );
  }
);
